export const resetOperations = (state) => {
  state.selectedOperation = '';
  state.paybackInfo = {};
  state.purchaseInfo = {};
  state.confirmModalInfo = {};
  state.moveOperationInfo = {};
  state.cloneOperationInfo = null;
  state.cropperInfo = {};
  state.eventSearchValue = '';
};
